import styled from 'styled-components';

const Button = styled.a`
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.04em;
  border-radius: 6px;
  padding: 11px 16px 9px;
  height: 40px;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color ease 0.3s;
  color: white;
  outline: none;

  &:visited,
  &:focus,
  &:active,
  &:hover {
    color: white;
    outline: none;
  }
`;
export const PurpleButton = styled(Button)`
  background: #9b51e0;
`;
export const BlueButton = styled(Button)`
  background: #12b7e7;
`;
export const BlueLink = styled.a`
  font-size: 16px;
  line-height: 22px;
  color: #12b7e7;
  cursor: pointer;

  &:visited,
  &:focus,
  &:active,
  &:hover {
    color: #12b7e7;
  }
`;

export const WhiteButtonWithBorder = styled.a`
  padding: 10px 16px;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.56px;
  text-transform: uppercase;
  color: #12b7e7;
  border-radius: 6px;
  border: 1px solid #12b7e7;
  background: #fff;
  cursor: pointer;

  &:visited,
  &:focus,
  &:active,
  &:hover {
    color: #12b7e7;
    border-color: #12b7e7;
  }
`;
